export const messages = {
  en: {
    editProduct: {
      title: 'Edit Product',
      productInfo: 'Product Information',
      productName: 'Product Name',
      productGroup: 'Product Group',
      unit: 'Unit',
      sort: 'Sort',
      keywords: 'Keywords',
      mobileMenu: 'Mobile Menu',
      warehouse: 'Warehouse',
      stockWarning: 'Stock Warning',
      productDesc: 'Product Description',
      productImages: 'Product Images',
      productCover: 'Product Cover',
      productCarousel: 'Product Carousel',
      productSpecs: 'Product Specifications',
      specName: 'Spec Name',
      stock: 'Stock',
      sales: 'Sales',
      price: 'Price/Points',
      costPrice: 'Cost Price',
      ownerPrice: 'Owner Price',
      vipPrice: 'VIP Price',
      marketPrice: 'Market Price',
      deduction: 'Deduction',
      barcode: 'Barcode',
      operations: 'Operations',
      delete: 'Delete',
      defaultSpec: 'Default Spec',
      productExtension: 'Product Extension',
      productStatus: 'Product Status',
      productDetails: 'Product Details',
      save: 'Save',
      cancel: 'Cancel',
      validation: {
        categoryRequired: 'Product category is required',
        nameRequired: 'Product name is required',
        nameMaxLength: 'Product name cannot exceed 128 characters',
        descRequired: 'Product description is required',
        descMaxLength: 'Product description cannot exceed 256 characters',
        keywordsRequired: 'Keywords are required',
        keywordsMaxLength: 'Keywords cannot exceed 256 characters',
        barcodeMaxLength: 'Barcode cannot exceed 15 characters',
        warehouseRequired: 'Warehouse is required',
        unitMaxLength: 'Unit cannot exceed 32 characters',
        sortFormat: 'Invalid sort format',
        stockWarningFormat: 'Invalid stock warning format',
        postageFormat: 'Invalid postage format',
        shippingFeeFormat: 'Invalid shipping fee format, e.g. 3.00'
      }
    }
  },
  zh: {
    editProduct: {
      title: '编辑商品',
      productInfo: '商品信息',
      productName: '商品名称',
      productGroup: '商品分组',
      unit: '单位',
      sort: '排序',
      keywords: '关键词',
      mobileMenu: '手机菜单',
      warehouse: '仓库',
      stockWarning: '库存警告',
      productDesc: '商品简介',
      productImages: '商品图片',
      productCover: '商品封面',
      productCarousel: '商品轮播',
      productSpecs: '商品规格',
      specName: '规格名称',
      stock: '库存',
      sales: '销量',
      price: '金额/积分',
      costPrice: '成本价',
      ownerPrice: '业主价',
      vipPrice: '会员价格',
      marketPrice: '市场价',
      deduction: '抵扣金',
      barcode: '条形码',
      operations: '操作',
      delete: '删除',
      defaultSpec: '默认规格',
      productExtension: '商品扩展',
      productStatus: '商品状态',
      productDetails: '商品详情',
      save: '保存',
      cancel: '取消',
      validation: {
        categoryRequired: '商品大类不能为空',
        nameRequired: '商品名称不能为空',
        nameMaxLength: '商品名称不能超过128位',
        descRequired: '商品简介不能为空',
        descMaxLength: '商品简介不能超过256位',
        keywordsRequired: '关键词不能为空',
        keywordsMaxLength: '关键词不能超过256位',
        barcodeMaxLength: '产品条码不能超过15位',
        warehouseRequired: '仓库不能为空',
        unitMaxLength: '单位不能超过32位',
        sortFormat: '排序格式错误',
        stockWarningFormat: '库存警告格式错误',
        postageFormat: '是否包邮格式错误',
        shippingFeeFormat: '邮费格式错误,请填写如 3.00'
      }
    }
  }
}